import { render, staticRenderFns } from "./amountOrder.vue?vue&type=template&id=1862a54e"
import script from "./amountOrder.vue?vue&type=script&lang=js"
export * from "./amountOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports